import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Calls from './components/Calls';
import Messages from './components/Messages';
import Contacts from './components/Contacts';
import ContactDetail from './components/ContactDetail';
import SuspectDetail from './components/SuspectDetail';
import Interview from './components/Interview';
import EvidenceDetail from './components/EvidenceDetail';
import Database from './components/Database';
import Login from './components/Login';
import BottomNavigation from './components/BottomNavigation';
import './App.css';

// Component to handle scroll to top on route changes
function ScrollToTop() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return null;
}

// Main App Component
function App() {
  const [databaseTab, setDatabaseTab] = useState('evidence');

  // Clear all caches on app start
  useEffect(() => {
    const clearAllCaches = async () => {
      try {
        // Clear service worker caches
        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(
            cacheNames.map(cacheName => caches.delete(cacheName))
          );
          console.log('All caches cleared');
        }
        
        // Clear localStorage and sessionStorage
        localStorage.clear();
        sessionStorage.clear();
        console.log('Storage cleared');
        
        // Force reload if service worker is active
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            await registration.unregister();
            console.log('Service worker unregistered');
          }
        }
      } catch (error) {
        console.log('Cache clearing error:', error);
      }
    };
    
    clearAllCaches();
  }, []);

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/calls" element={<Calls />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/contact/:contactId" element={<ContactDetail />} />
          <Route path="/database" element={<Database activeTab={databaseTab} setActiveTab={setDatabaseTab} />} />
          <Route 
            path="/suspect/:suspectId" 
            element={
              <div className="app-container">
                <SuspectDetail />
                <BottomNavigation showNavigation={true} />
              </div>
            } 
          />
          <Route 
            path="/interview/:suspectId" 
            element={
              <div className="app-container">
                <Interview />
                <BottomNavigation showNavigation={true} />
              </div>
            } 
          />
          <Route 
            path="/evidence/:evidenceId" 
            element={
              <div className="app-container">
                <EvidenceDetail />
                <BottomNavigation showNavigation={true} />
              </div>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;